import React, { Component } from "react";
import filter from "../assets/filter.png";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { NumericFormat } from "react-number-format";
import CustomButton from "../components/CustomButton";
import { Modal, Form } from "react-bootstrap";
import Cancel from "../assets/cancel.svg";
import Tick from "../assets/tick.svg";
import { WhisperSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";
import Paginator from "../components/Paginator";
import PieChart, { Connector, Font, Size } from "devextreme-react/pie-chart";
import fileExcel from "@iconify/icons-la/file-excel";
import downloadIcon from "@iconify/icons-la/download";
import {
  Chart,
  Series,
  CommonSeriesSettings,
  Label,
  Legend,
  ArgumentAxis,
  ValueAxis,
} from "devextreme-react/chart";
import QuestionView from "../components/QuestionView";
import PollAnswers from "../components/PollAnswers";
import "react-circular-progressbar/dist/styles.css";

import DatePicker, { DateObject } from "react-multi-date-picker";
import moment from "moment-jalaali";
import "react-multi-date-picker/styles/layouts/mobile.css";
import "react-multi-date-picker/styles/layouts/prime.css";
import "react-multi-date-picker/styles/colors/bluee.css";
import poor from "../assets/poor.svg";
import middle from "../assets/middle.svg";
import good from "../assets/good.svg";
import excellent from "../assets/excellent.svg";
import poor1 from "../assets/poor1.svg";
import middle1 from "../assets/middle1.svg";
import good1 from "../assets/good1.svg";
import excellent1 from "../assets/excellent1.svg";
import {
  BaseUrl,
  ClubAuthorization,
  isUser,
  LogoutFunction,
} from "../static.js";

export default class PollReports extends Component {
  constructor(props) {
    super(props);

    let questions = [];
    this.props.Questions.forEach((element) => {
      questions.push(element.id);
    });

    this.state = {
      columnDefs1: [
        {
          headerName: "شناسه مشترک",
          field: "accountForeignId",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نام مشترک",
          field: "accountName",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "موبايل مشترک",
          field: "phone",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نام کاربر ثبت کننده",
          field: "userName",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نام گارسن",
          field: "garconName",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نام پيک",
          field: "outputName",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "شماره فاکتور",
          field: "invoiceForeignId",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نوع سرويس",
          field: "serviceTypeId",
          cellRenderer: "formatServiceName",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مبلغ کل",
          field: "totalPrice",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "کامنت",
          field: "comment",
          // cellRenderer: "formatComment",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
            maxWidth: "300px",
            wordWrap: "normal",
          },
          wrapText: true,
          autoHeight: true,
          lockPosition: true,
        },
        {
          headerName: "تاریخ سفارش",
          field: "invoicePersianCreatedOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      columnDefs2: [
        {
          headerName: "شناسه مشترک",
          field: "accountForeignId",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نام مشترک",
          field: "accountName",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "موبايل مشترک",
          field: "phone",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "متن سوال",
          field: "text",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "جواب",
          field: "response",
          cellRenderer: "formatAnswer",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نام کاربر ثبت کننده",
          field: "userName",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نام گارسن",
          field: "garconName",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نام پيک",
          field: "outputName",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "شماره فاکتور",
          field: "invoiceForeignId",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نوع سرويس",
          field: "serviceTypeId",
          cellRenderer: "formatServiceName",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "مبلغ کل",
          field: "totalPrice",
          cellRenderer: "formatCurrency",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ سفارش",
          field: "invoicePersianCreatedOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      columnDefs: [],
      rowData: [],
      frameworkComponents: {
        formatCurrency: this.formatCurrency,
        formatServiceName: this.formatServiceName,
        PollAnswers: PollAnswers,
        formatAnswer: this.formatAnswer,
        formatComment: this.formatComment,
      },
      currentPage: 1,
      totalPages: 1,
      justTableLoading: false,
      ModalShow: false,
      dateValue1: moment().add(-1, "months").format("jYYYY/jMM/jDD"),
      maxDateStart: moment().add(-1, "days").format("jYYYY/jMM/jDD"),
      dateValue2: moment().format("jYYYY/jMM/jDD"),
      maxDate: moment().add(0, "days").format("jYYYY/jMM/jDD"),
      minDate: null,
      reportSelected: 0,
      noLimit: true,
      timeLimit: false,
      insideCheck: true,
      packCheck: true,
      sendCheck: true,
      poorState: true,
      middleState: true,
      goodState: true,
      excellentState: true,
      chartData: [],
      thisWidth: 0,
      thisHeight: 0,
      tableContainerWidth: 0,
      tableContainerHeight: 0,
      ModalShow2: false,
      selectedQuestions: questions,
      dataLoading: false,
      tableHasFilter: false,
      ExcelDateModal: false,
      excelProgress: false,
    };

    this.tableContainer = React.createRef();
    this.datepicker1 = React.createRef();
    this.datepicker2 = React.createRef();

    this.chartRef = React.createRef();

    this.getReport1 = this.getReport1.bind(this);
    this.getReport2 = this.getReport2.bind(this);
    this.getReport3 = this.getReport3.bind(this);
    this.getReport4 = this.getReport4.bind(this);

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.getReport1();

    window.addEventListener("resize", this.updateWindowDimensions);
    this.updateWindowDimensions();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  formatComment(params) {
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div className="commentStyle">{params.value}</div>
      </div>
    );
  }

  formatCurrency(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      return (
        <NumericFormat
          value={params.value}
          displayType={"text"}
          thousandSeparator={true}
          suffix={" ریال"}
        />
      );
    } catch (error) {
      return "-";
    }
  }

  formatAnswer(params) {
    try {
      if (
        params.value === "null" ||
        params.value === "" ||
        params.value === 0 ||
        params.value === null
      )
        return "-";
      else {
        if (params.value.toString() === "1") return "ضعیف";
        if (params.value.toString() === "2") return "متوسط";
        if (params.value.toString() === "3") return "خوب";
        if (params.value.toString() === "4") return "عالی";
        else return "-";
      }
    } catch (error) {
      return "-";
    }
  }

  formatServiceName(params) {
    if (
      params.value === "null" ||
      params.value === "" ||
      params.value === 0 ||
      params.value === null
    )
      return "-";
    else {
      if (params.value.toString() === "0") return "داخلی";
      if (params.value.toString() === "1") return "بسته بندی";
      if (params.value.toString() === "2") return "ارسال";
      else return "-";
    }
  }

  updateWindowDimensions() {
    try {
      window.setTimeout(() => {
        if (this.tableContainer.current) {
          let w =
            this.tableContainer.current.getBoundingClientRect().width * 0.9 >
            500
              ? 500
              : this.tableContainer.current.getBoundingClientRect().width * 0.9;
          let h = this.tableContainer.current.getBoundingClientRect().height;

          this.setState(
            {
              thisWidth: w,
              thisHeight: h < w ? h * 0.8 : w - 10,
              tableContainerWidth:
                this.tableContainer.current.getBoundingClientRect().width,
              tableContainerHeight:
                this.tableContainer.current.getBoundingClientRect().height,
            },
            () => {
              if (this.chartRef.current)
                this.chartRef.current.instance.render();
            }
          );
        }
      }, 100);
    } catch (error) {}
  }

  // componentDidUpdate(prevProps) {
  //   if (
  //     prevProps.thisSizeChangeW !== this.props.thisSizeChangeW ||
  //     prevProps.thisSizeChangeH !== this.props.thisSizeChangeH
  //   ) {
  //     this.chartRef.current.instance.render();
  //   }
  // }

  onFilterClick() {
    if (this.state.dataLoading) return;
    this.setState({ ModalShow: true });
  }

  onFilterClear() {
    if (this.state.dataLoading) return;
    // this.resetModalValues();
    // this.GetAccounts(1, null, null, null, null, null, false);

    let questions = [];
    this.props.Questions.forEach((element) => {
      questions.push(element.id);
    });

    this.setState(
      {
        noLimit: true,
        timeLimit: false,
        insideCheck: true,
        packCheck: true,
        sendCheck: true,
        poorState: true,
        middleState: true,
        goodState: true,
        excellentState: true,
        selectedQuestions: questions,
        tableHasFilter: false,
        currentPage: 1,
      },
      () => {
        switch (this.state.reportSelected) {
          case 0: {
            this.getReport1();
            break;
          }
          case 1: {
            this.getReport2();
            break;
          }
          case 2: {
            this.getReport3();
            break;
          }
          case 3: {
            this.getReport4();
            break;
          }
          default:
            break;
        }
      }
    );
  }

  onFirstDataRendered(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = params.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });

        if (
          width <
          this.tableContainer.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer.current.getBoundingClientRect().width -
            10 -
            width;
          if (def > cols.length) {
            let newwidth = def / cols.length;
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
      }, 50);
    } catch (error) {}
  }

  onFirstPageClick() {
    if (this.state.dataLoading) return;
    this.setState({ currentPage: 1 }, () => {
      switch (this.state.reportSelected) {
        case 0: {
          this.getReport1();
          break;
        }
        case 1: {
          this.getReport2();
          break;
        }
        case 2: {
          this.getReport3();
          break;
        }
        case 3: {
          this.getReport4();
          break;
        }
        default:
          break;
      }
    });
  }

  onPreviousPageClick() {
    if (this.state.dataLoading) return;
    this.setState({ currentPage: this.state.currentPage - 1 }, () => {
      switch (this.state.reportSelected) {
        case 0: {
          this.getReport1();
          break;
        }
        case 1: {
          this.getReport2();
          break;
        }
        case 2: {
          this.getReport3();
          break;
        }
        case 3: {
          this.getReport4();
          break;
        }
        default:
          break;
      }
    });
  }

  onNextPageClick() {
    if (this.state.dataLoading) return;
    this.setState({ currentPage: this.state.currentPage + 1 }, () => {
      switch (this.state.reportSelected) {
        case 0: {
          this.getReport1();
          break;
        }
        case 1: {
          this.getReport2();
          break;
        }
        case 2: {
          this.getReport3();
          break;
        }
        case 3: {
          this.getReport4();
          break;
        }
        default:
          break;
      }
    });
  }

  onLastPageClick() {
    if (this.state.dataLoading) return;
    this.setState({ currentPage: this.state.totalPages }, () => {
      switch (this.state.reportSelected) {
        case 0: {
          this.getReport1();
          break;
        }
        case 1: {
          this.getReport2();
          break;
        }
        case 2: {
          this.getReport3();
          break;
        }
        case 3: {
          this.getReport4();
          break;
        }
        default:
          break;
      }
    });
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  fixNumber(str) {
    var persianNumbers = [
        /۰/g,
        /۱/g,
        /۲/g,
        /۳/g,
        /۴/g,
        /۵/g,
        /۶/g,
        /۷/g,
        /۸/g,
        /۹/g,
      ],
      arabicNumbers = [
        /٠/g,
        /١/g,
        /٢/g,
        /٣/g,
        /٤/g,
        /٥/g,
        /٦/g,
        /٧/g,
        /٨/g,
        /٩/g,
      ];
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  }

  GetPollCommentsExcel() {
    let date1 = "";
    let date2 = "";

    date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format("YYYY-MM-DD");
    date2 = moment(this.state.dateValue2, "jYYYY/jMM/jDD").format("YYYY-MM-DD");

    let filter = new URLSearchParams({
      restaurantId: this.props.restaurantId,
      fromDate: date1 + " 00:00:00",
      toDate: date2 + " 23:59:59",
    });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    this.setState({ excelProgress: true });
    fetch("https://94.101.187.196/api/Report/GetPollCommentsExcel?" + filter, {
      method: "GET",
      headers: { Authorization: jsonString },
    })
      .then((res) => {
        if (res.status !== 200) {
          return res.json();
        }
        return res.body;
      })
      .then((result) => {
        if (result.errorMessage) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          return null;
        } else {
          return result;
        }
      })
      .then((stream) => new Response(stream))
      .then((response) => response.blob())
      .then((blob) => {
        if (blob.size === 0) {
          return null;
        }
        return URL.createObjectURL(blob);
      })
      .then((url) => {
        this.setState({ excelProgress: false });
        if (!url) return;
        const link = document.createElement("a");
        link.href = url;
        link.download =
          "PollComments_" +
          moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
            "jYYYY-jMM-jDD"
          ) +
          "_" +
          moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
            "jYYYY-jMM-jDD"
          ) +
          ".xlsx";
        document.body.appendChild(link);
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
        document.body.removeChild(link);
      })
      .catch((err) => {
        this.setState({ excelProgress: false });
        console.log(err);
        toast.error(err.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });
      });
  }

  GetPollResultsDetailExcel() {
    let date1 = "";
    let date2 = "";

    date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format("YYYY-MM-DD");
    date2 = moment(this.state.dateValue2, "jYYYY/jMM/jDD").format("YYYY-MM-DD");

    let filter = new URLSearchParams({
      restaurantId: this.props.restaurantId,
      fromDate: date1 + " 00:00:00",
      toDate: date2 + " 23:59:59",
    });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    this.setState({ excelProgress: true });
    fetch(
      "https://94.101.187.196/api/Report/GetPollResultsDetailExcel?" + filter,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status !== 200) {
          return res.json();
        }
        return res.body;
      })
      .then((result) => {
        if (result.errorMessage) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          return null;
        } else {
          return result;
        }
      })
      .then((stream) => new Response(stream))
      .then((response) => response.blob())
      .then((blob) => {
        if (blob.size === 0) {
          return null;
        }
        return URL.createObjectURL(blob);
      })
      .then((url) => {
        this.setState({ excelProgress: false });
        if (!url) return;
        const link = document.createElement("a");
        link.href = url;
        link.download =
          "PollDetails_" +
          moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
            "jYYYY-jMM-jDD"
          ) +
          "_" +
          moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
            "jYYYY-jMM-jDD"
          ) +
          ".xlsx";
        document.body.appendChild(link);
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
        document.body.removeChild(link);
      })
      .catch((err) => {
        this.setState({ excelProgress: false });
        console.log(err);
        toast.error(err.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });
      });
  }

  dateChange1(dateValue) {
    // console.log("dateValue1: ", dateValue);
    try {
      this.datepicker1.current.closeCalendar();
      this.datepicker2.current.closeCalendar();
    } catch (error) {}
    // console.log(dateValue);
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    // console.log(value);
    this.setState({ dateValue1: value, minDate: value }, () => {
      // switch (this.state.reportSelected) {
      //     case 1:{
      //         this.reportingByPOSType()
      //         break;
      //     }
      //     case 2:{
      //         this.reportingByCategory()
      //         break;
      //     }
      //     case 3:{
      //         this.reportingByProduct()
      //         break;
      //     }
      //     case 4:{
      //         this.reportingByCustomers()
      //         break;
      //     }
      //     default:
      //         break;
      // }
    });
  }

  dateChange2(dateValue) {
    try {
      this.datepicker1.current.closeCalendar();
      this.datepicker2.current.closeCalendar();
    } catch (error) {}

    // console.log(dateValue);
    let value = this.fixNumber(new DateObject(dateValue).format("YYYY/MM/DD"));
    this.setState({ dateValue2: value, minDate: value }, () => {
      // switch (this.state.reportSelected) {
      //     case 1:{
      //         this.reportingByPOSType()
      //         break;
      //     }
      //     case 2:{
      //         this.reportingByCategory()
      //         break;
      //     }
      //     case 3:{
      //         this.reportingByProduct()
      //         break;
      //     }
      //     case 4:{
      //         this.reportingByCustomers()
      //         break;
      //     }
      //     default:
      //         break;
      // }
    });
  }

  onConfirm() {
    if (this.state.dataLoading) return;

    // if (!this.state.noLimit || !this.state.insideCheck || packCheck || sendCheck || poorState || middleState
    //     timeLimit: false,
    //     insideCheck: true,
    //     packCheck: true,
    //     sendCheck: true,
    //     poorState: true,
    //     middleState: true,
    //     goodState: true,
    //     excellentState: true,
    //     selectedQuestions: questions,
    //     tableHasFilter: false,
    //     currentPage: 1,)
    this.setState({ currentPage: 1, ModalShow: false }, () => {
      switch (this.state.reportSelected) {
        case 0: {
          this.getReport1();
          break;
        }
        case 1: {
          this.getReport2();
          break;
        }
        case 2: {
          this.getReport3();
          break;
        }
        case 3: {
          this.getReport4();
          break;
        }
        default:
          break;
      }
    });
  }

  reportChangeClick(id) {
    if (this.state.dataLoading) return;
    this.setState({ reportSelected: id }, () => {
      switch (id) {
        case 0: {
          this.getReport1();
          break;
        }
        case 1: {
          this.getReport2();
          break;
        }
        case 2: {
          this.getReport3();
          break;
        }
        case 3: {
          this.getReport4();
          break;
        }
        default:
          break;
      }
    });
  }

  onPoorClick() {
    this.setState({ poorState: !this.state.poorState });
  }

  onMiddleClick() {
    this.setState({ middleState: !this.state.middleState });
  }

  onGoodClick() {
    this.setState({ goodState: !this.state.goodState });
  }

  onExcellentClick() {
    this.setState({ excellentState: !this.state.excellentState });
  }

  getReport1() {
    let date1 = "";
    let date2 = "";
    let filter = new URLSearchParams({
      restaurantId: this.props.restaurantId,
    });
    if (!this.state.noLimit) {
      date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
        "YYYY-MM-DD"
      );
      date2 = moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
        "YYYY-MM-DD"
      );

      filter = new URLSearchParams({
        restaurantId: this.props.restaurantId,
        fromDate: date1 + " 00:00:00",
        toDate: date2 + " 23:59:59",
      });
    }

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());

    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    this.setState({ dataLoading: true, tableHasFilter: !this.state.noLimit });
    fetch("https://94.101.187.196/api/Report/GetPollParticipation?" + filter, {
      method: "GET",
      headers: { Authorization: jsonString },
    })
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log("GetPollParticipation: ", result);
        let data = [];
        data.push({
          title: "نظرسنجی های انجام شده",
          value: result.results[0]["completedPollCount"],
        });
        data.push({
          title: "نظرسنجی های انجام نشده",
          value: result.results[0]["notCompletedPollCount"],
        });
        this.setState({ chartData: data, dataLoading: false });
      })
      .catch((err) => {
        this.setState({ dataLoading: false });
        console.log(err);
      });
  }

  getReport2() {
    let date1 = "";
    let date2 = "";

    let service = "";
    if (this.state.insideCheck) {
      if (service === "") service = "0";
      else service += ",0";
    }

    if (this.state.packCheck) {
      if (service === "") service = "1";
      else service += ",1";
    }

    if (this.state.sendCheck) {
      if (service === "") service = "2";
      else service += ",2";
    }

    let filter = new URLSearchParams({
      restaurantId: this.props.restaurantId,
      serviceType: service,
    });

    if (!this.state.noLimit) {
      date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
        "YYYY-MM-DD"
      );
      date2 = moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
        "YYYY-MM-DD"
      );

      filter = new URLSearchParams({
        restaurantId: this.props.restaurantId,
        fromDate: date1 + " 00:00:00",
        toDate: date2 + " 23:59:59",
        serviceType: service,
      });
    }

    this.setState({
      dataLoading: true,
      tableHasFilter: !this.state.noLimit || service !== "0,1,2",
    });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch("https://94.101.187.196/api/Report/GetPollResults?" + filter, {
      method: "GET",
      headers: { Authorization: jsonString },
    })
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        // console.log("GetPollResults: ", result);
        let data = [];

        result.results.forEach((element) => {
          let object = {};
          object["text"] = element.text;
          element.pollResultAnswers.forEach((element1) => {
            object[element1.response] = element1.count;
          });
          data.push(object);
        });

        // data = [
        //   { text: "رفتار پرسنل صندوق", 1: 2, 2: 5, 3: 4, 4: 11 },
        //   { text: "رفتار پرسنل سالن", 1: 2, 2: 5, 3: 4, 4: 11 },
        //   { text: "کیفیت غذا", 1: 2, 2: 5, 3: 4, 4: 11 },
        //   { text: "برخورد پرسنل", 1: 2, 2: 5, 3: 4, 4: 11 },
        //   { text: "برخورد پرسنل1", 1: 2, 2: 5, 3: 4, 4: 11 },
        //   { text: "برخورد پرسنل2", 1: 2, 2: 5, 3: 4, 4: 11 },
        //   { text: "برخورد پرسنل3", 1: 2, 2: 5, 3: 4, 4: 11 },
        //   { text: "برخورد پرسنل4", 1: 2, 2: 5, 3: 4, 4: 11 },
        //   { text: "برخورد پرسنل5", 1: 2, 2: 5, 3: 4, 4: 11 },
        //   { text: "برخورد پرسنل6", 1: 2, 2: 5, 3: 4, 4: 11 },
        //   { text: "برخورد پرسنل7", 1: 2, 2: 5, 3: 4, 4: 11 },
        //   { text: "برخورد پرسنل8", 1: 2, 2: 5, 3: 4, 4: 11 },
        // ];

        // data.push({
        //   text: "نظرسنجی های انجام شده",
        //   value: result.results[0]["completedPollCount"],
        // });
        // data.push({
        //   title: "نظرسنجی های انجام نشده",
        //   value: result.results[0]["notCompletedPollCount"],
        // });
        this.setState({ chartData: data, dataLoading: false });
      })
      .catch((err) => {
        this.setState({ dataLoading: false });
        console.log(err);
      });
  }

  getReport3() {
    let date1 = "";
    let date2 = "";

    let service = "";
    if (this.state.insideCheck) {
      if (service === "") service = "0";
      else service += ",0";
    }

    if (this.state.packCheck) {
      if (service === "") service = "1";
      else service += ",1";
    }

    if (this.state.sendCheck) {
      if (service === "") service = "2";
      else service += ",2";
    }

    let filter = new URLSearchParams({
      restaurantId: this.props.restaurantId,
      serviceType: service,
      page: this.state.currentPage,
    });

    if (!this.state.noLimit) {
      date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
        "YYYY-MM-DD"
      );
      date2 = moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
        "YYYY-MM-DD"
      );

      filter = new URLSearchParams({
        restaurantId: this.props.restaurantId,
        fromDate: date1 + " 00:00:00",
        toDate: date2 + " 23:59:59",
        serviceType: service,
        page: this.state.currentPage,
      });
    }

    this.setState({
      dataLoading: true,
      tableHasFilter: !this.state.noLimit || service !== "0,1,2",
    });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch("https://94.101.187.196/api/Report/GetPollComments?" + filter, {
      method: "GET",
      headers: { Authorization: jsonString },
    })
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        this.setState({ columnDefs: [], rowData: [] }, () => {
          this.setState({
            columnDefs: this.state.columnDefs1,
            rowData: result.results[0].pageData,
            currentPage: result.results[0].currentPage,
            totalPages: result.results[0].totalPages,
            dataLoading: false,
          });
        });
      })
      .catch((err) => {
        this.setState({ dataLoading: false });
        console.log(err);
      });
  }

  getReport4() {
    let date1 = "";
    let date2 = "";
    let service = "";
    if (this.state.insideCheck) {
      if (service === "") service = "0";
      else service += ",0";
    }

    if (this.state.packCheck) {
      if (service === "") service = "1";
      else service += ",1";
    }

    if (this.state.sendCheck) {
      if (service === "") service = "2";
      else service += ",2";
    }

    let questions = "";
    this.state.selectedQuestions.forEach((element) => {
      if (questions === "") questions = element.toString();
      else questions += "," + element;
    });

    let answers = "";
    if (this.state.poorState) {
      if (answers === "") answers = "1";
      else answers += ",1";
    }

    if (this.state.middleState) {
      if (answers === "") answers = "2";
      else answers += ",2";
    }

    if (this.state.goodState) {
      if (answers === "") answers = "3";
      else answers += ",3";
    }

    if (this.state.excellentState) {
      if (answers === "") answers = "4";
      else answers += ",4";
    }
    let filter = new URLSearchParams({
      restaurantId: this.props.restaurantId,
      serviceType: service,
      page: this.state.currentPage,
      questionsType: questions,
      answerType: answers,
    });

    if (!this.state.noLimit) {
      date1 = moment(this.state.dateValue1, "jYYYY/jMM/jDD").format(
        "YYYY-MM-DD"
      );
      date2 = moment(this.state.dateValue2, "jYYYY/jMM/jDD").format(
        "YYYY-MM-DD"
      );

      filter = new URLSearchParams({
        restaurantId: this.props.restaurantId,
        fromDate: date1 + " 00:00:00",
        toDate: date2 + " 23:59:59",
        serviceType: service,
        page: this.state.currentPage,
        questionsType: questions,
        answerType: answers,
      });
    }

    this.setState({
      dataLoading: true,
      tableHasFilter:
        !this.state.noLimit || service !== "0,1,2" || answers !== "1,2,3,4",
    });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch("https://94.101.187.196/api/Report/GetPollResultsDetail?" + filter, {
      method: "GET",
      headers: { Authorization: jsonString },
    })
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        // console.log("GetPollResultsDetail: ", result);
        this.setState({ columnDefs: [], rowData: [] }, () => {
          this.setState({
            columnDefs: this.state.columnDefs2,
            rowData: result.results[0].pageData,
            currentPage: result.results[0].currentPage,
            totalPages: result.results[0].totalPages,
            dataLoading: false,
          });
        });
      })
      .catch((err) => {
        this.setState({ dataLoading: false });
        console.log(err);
      });
  }

  hideModal2() {
    this.setState({ ModalShow2: false });
  }

  onChooseQuestionsClick() {
    this.setState({ ModalShow2: true });
  }

  onConfirmQuestions(list) {
    this.setState({ selectedQuestions: list, ModalShow2: false });
  }

  render() {
    return (
      <div
        className="reportContaner"
        style={{ marginBottom: "100px", height: "unset" }}
      >
        <div className="reportTitleBar">گزارش نظرسنجی</div>
        <div
          className="reportContent"
          style={{ paddingTop: "10px", paddingBottom: "10px" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
              width: "100%",
              maxWidth: "1200px",
            }}
          >
            <div
              className="reportButton"
              onClick={this.reportChangeClick.bind(this, 0)}
              style={{
                backgroundColor:
                  this.state.reportSelected === 0 ? "#d6783a3a" : "transparent",
                borderColor:
                  this.state.reportSelected === 0
                    ? "var(--brown1)"
                    : "var(--brown3)",
              }}
            >
              میزان نظرسنجی
            </div>

            <div
              className="reportButton"
              onClick={this.reportChangeClick.bind(this, 1)}
              style={{
                backgroundColor:
                  this.state.reportSelected === 1 ? "#d6783a5d" : "transparent",
                borderColor:
                  this.state.reportSelected === 1
                    ? "var(--brown1)"
                    : "var(--brown3)",
              }}
            >
              گزارش نظرسنجی
            </div>

            <div
              className="reportButton"
              onClick={this.reportChangeClick.bind(this, 2)}
              style={{
                backgroundColor:
                  this.state.reportSelected === 2 ? "#d6783a5d" : "transparent",
                borderColor:
                  this.state.reportSelected === 2
                    ? "var(--brown1)"
                    : "var(--brown3)",
              }}
            >
              گزارش کامنت‌ها
            </div>

            <div
              className="reportButton"
              onClick={this.reportChangeClick.bind(this, 3)}
              style={{
                backgroundColor:
                  this.state.reportSelected === 3 ? "#d6783a5d" : "transparent",
                borderColor:
                  this.state.reportSelected === 3
                    ? "var(--brown1)"
                    : "var(--brown3)",
              }}
            >
              جزئیات نظرسنجی
            </div>
          </div>
          <div
            style={{
              width: "100%",
              minHeight: "1px",
              backgroundColor: "var(--gray2)",
              margin: "15px",
            }}
          />
          <div className="pageContents" style={{ marginTop: "0px" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <div style={{ display: "flex", flexDirection: "row" }}>
                <CustomButton
                  title="اعمال فیلتر"
                  whiteSpace="noWrap"
                  imgHeight={20}
                  imgWidth={25}
                  flexDirection="row-reverse"
                  minHeight="35px"
                  img={filter}
                  onClick={this.onFilterClick.bind(this)}
                />
                <div style={{ minWidth: "10px" }} />
                {this.state.tableHasFilter && (
                  <CustomButton
                    title="حذف فیلترها"
                    whiteSpace="noWrap"
                    imgHeight={20}
                    imgWidth={25}
                    backColor="var(--red1)"
                    flexDirection="row-reverse"
                    minHeight="35px"
                    img={Cancel}
                    onClick={this.onFilterClear.bind(this)}
                  />
                )}

                <div style={{ minWidth: "10px" }} />
                {this.state.reportSelected > 1 && (
                  <CustomButton
                    title="خروجی اکسل"
                    whiteSpace="noWrap"
                    imgHeight={20}
                    imgWidth={25}
                    flexDirection="row-reverse"
                    minHeight="35px"
                    ico={fileExcel}
                    onClick={() => {
                      this.setState({ ExcelDateModal: true });
                    }}
                  />
                )}
              </div>
            </div>
            <div
              className="tableContainer ag-theme-alpine"
              style={{
                alignItems: this.state.reportSelected < 2 ? "center" : "unset",
                justifyContent: "center",
              }}
              ref={this.tableContainer}
            >
              {this.state.reportSelected > 1 && !this.state.dataLoading && (
                <AgGridReact
                  enableRtl={true}
                  autoHeight={true}
                  animateRows={true}
                  enableBrowserTooltips={true}
                  tooltipMouseTrack={true}
                  suppressSizeToFit={false}
                  columnDefs={this.state.columnDefs}
                  localeText={this.props.gridLocaleText}
                  rowData={this.state.rowData}
                  suppressDragLeaveHidesColumns={true}
                  suppressMovable={true}
                  skipHeaderOnAutoSize={false}
                  onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                  rowHeight={window.innerWidth <= 587 ? 40 : 50}
                  headerHeight={window.innerWidth <= 587 ? 40 : 50}
                  frameworkComponents={this.state.frameworkComponents}
                  enableCellTextSelection={true}
                  ensureDomOrder={true}
                ></AgGridReact>
              )}

              {this.state.reportSelected === 0 && !this.state.dataLoading && (
                <PieChart
                  ref={this.chartRef}
                  rtlEnabled
                  id="pie"
                  palette={["#d6783a", "#a49586"]}
                  dataSource={this.state.chartData}
                  // dataSource={[{title:'aaa',value:2,amount:1200},{title:'bbb',value:5,amount:1800}]}
                  // palette="Material"
                  // resolveLabelOverlapping='shift'
                >
                  <Legend
                    orientation="horizontal"
                    itemTextPosition="left"
                    horizontalAlignment="center"
                    columnCount={1}
                    // columnItemSpacing={40}
                    verticalAlignment="bottom"
                  >
                    <Font family="SFUIDisplay" />
                  </Legend>
                  <Series argumentField="title" valueField="value">
                    <Label
                      visible={true}
                      // backgroundColor={
                      //   !this.state.ModalShow ? undefined : "var(--brown1)"
                      // }
                      // customizeText={this.creditValue}
                      wordWrap="none"
                      textOverflow="none"
                    >
                      <Connector
                        visible={true}
                        width={1}
                        // color={
                        //   !this.state.ModalShow ? undefined : "var(--brown1)"
                        // }
                      />
                      <Font color="white" family="SFUIDisplay" size={14} />
                    </Label>
                    {/* <SmallValuesGrouping
                      topCount={10}
                      mode="topN"
                      groupName="سایر"
                    /> */}
                  </Series>

                  <Size
                    height={this.state.thisHeight}
                    width={this.state.thisWidth}
                  />
                </PieChart>
              )}

              {this.state.reportSelected === 1 && !this.state.dataLoading && (
                <Chart
                  ref={this.chartRef}
                  id="chart"
                  resolveLabelOverlapping="stack"
                  dataSource={this.state.chartData}
                  rtlEnabled
                  rotated={
                    this.state.tableContainerHeight >
                    this.state.tableContainerWidth
                      ? true
                      : false
                  }
                >
                  <ArgumentAxis>
                    {/* or ValueAxis, or CommonAxisSettings */}
                    <Label
                      overlappingBehavior="rotate"
                      rotationAngle={90}
                      // staggeringSpacing={20}
                      // displayMode="stagger"
                    >
                      <Font family="SFUIDisplayBold" />
                    </Label>
                  </ArgumentAxis>

                  <ValueAxis>
                    {/* or ValueAxis, or CommonAxisSettings */}
                    <Label
                    // customizeText={this.formatTime2}
                    >
                      <Font family="SFUIDisplayBold" />
                    </Label>
                  </ValueAxis>

                  <CommonSeriesSettings
                    argumentField="text"
                    type="bar"
                    hoverMode="allArgumentPoints"
                    selectionMode="allArgumentPoints"
                    ignoreEmptyPoints={true}
                    // barOverlapGroup="text"
                  >
                    <Label visible={true} wordWrap="none" textOverflow="none">
                      <Font family="SFUIDisplayBold" />
                    </Label>
                  </CommonSeriesSettings>
                  <Series valueField="1" name="ضعیف" color="var(--red1)">
                    <Label>
                      <Font color="white" />
                    </Label>
                  </Series>
                  <Series valueField="2" name="متوسط" color="var(--yellow1)">
                    <Label>
                      <Font color="white" />
                    </Label>
                  </Series>
                  <Series valueField="3" name="خوب" color="var(--blue1)">
                    <Label>
                      <Font color="black" />
                    </Label>
                  </Series>
                  <Series valueField="4" name="عالی" color="var(--green2)">
                    <Label>
                      <Font color="white" />
                    </Label>
                  </Series>
                  <Legend
                    orientation="horizontal"
                    itemTextPosition="left"
                    horizontalAlignment="center"
                    verticalAlignment="bottom"
                  >
                    <Font
                      color="var(--black1)"
                      family="SFUIDisplayBold"
                      size={11}
                    />
                  </Legend>
                  <Size
                    height={this.state.tableContainerHeight * 0.95}
                    width={this.state.tableContainerWidth * 0.95}
                  />
                  {/* <Export enabled={true} /> */}
                </Chart>
              )}

              {this.state.dataLoading && (
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    height: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <WhisperSpinner
                    size={30}
                    color="var(--brown1)"
                    frontColor="var(--brown1)"
                    backColor="var(--brown1)"
                    loading={true}
                  />
                </div>
              )}
            </div>
            <div
              style={{
                width: "100%",
                marginTop: "15px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {this.state.reportSelected > 1 && (
                <Paginator
                  currentPage={this.state.currentPage}
                  totalPages={this.state.totalPages}
                  onFirstPageClick={this.onFirstPageClick.bind(this)}
                  onPreviousPageClick={this.onPreviousPageClick.bind(this)}
                  onNextPageClick={this.onNextPageClick.bind(this)}
                  onLastPageClick={this.onLastPageClick.bind(this)}
                />
              )}
            </div>
          </div>
        </div>

        <Modal
          show={this.state.ModalShow}
          size="sm"
          animation={true}
          onHide={this.hideModal.bind(this)}
          centered
        >
          <div className="settingContainer" style={{ padding: "10px" }}>
            <div className="ModalTitleSM">فیلتر</div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                marginTop: "20px",
                padding: "5px",
                width: "100%",
              }}
            >
              <div
                className="settingItemContainer"
                style={{ direction: "ltr" }}
              >
                <Form.Check
                  type="checkbox"
                  label="بدون محدودیت"
                  checked={this.state.noLimit}
                  onChange={() =>
                    this.setState({
                      noLimit: !this.state.noLimit,
                      timeLimit: this.state.noLimit,
                    })
                  }
                />
                <Form.Check
                  type="checkbox"
                  label="فیلتر بازه زمانی"
                  checked={this.state.timeLimit}
                  onChange={() =>
                    this.setState({
                      timeLimit: !this.state.timeLimit,
                      noLimit: this.state.timeLimit,
                    })
                  }
                />
              </div>

              <div className="settingItemContainer">
                <div
                  className="settingLabel"
                  style={{
                    color: this.state.noLimit
                      ? "var(--gray3)"
                      : "var(--black1)",
                  }}
                >
                  شروع:
                </div>
                <DatePicker
                  ref={this.datepicker1}
                  value={this.state.dateValue1}
                  inputClass="form-control inputStyleForm textAlignCenter"
                  calendar="persian"
                  locale="fa"
                  weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                  format="YYYY/MM/DD"
                  animation
                  className="rmdp-mobile bluee"
                  onChange={(valuee) => this.dateChange1(valuee)}
                  maxDate={this.state.maxDateStart}
                  editable={false}
                  inputMode="none"
                  placeholder="شروع"
                  disabled={this.state.noLimit}
                />
              </div>
              <div className="settingItemContainer">
                <div
                  className="settingLabel"
                  style={{
                    color: this.state.noLimit
                      ? "var(--gray3)"
                      : "var(--black1)",
                  }}
                >
                  پایان:
                </div>
                <DatePicker
                  ref={this.datepicker2}
                  value={this.state.dateValue2}
                  inputClass="form-control inputStyleForm textAlignCenter"
                  calendar="persian"
                  locale="fa"
                  weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                  format="YYYY/MM/DD"
                  animation
                  className="rmdp-mobile bluee"
                  onChange={(valuee) => this.dateChange2(valuee)}
                  minDate={this.state.minDate}
                  maxDate={this.state.maxDate}
                  editable={false}
                  inputMode="none"
                  placeholder="پایان"
                  disabled={this.state.noLimit}
                />
              </div>

              {this.state.reportSelected > 0 && (
                <div
                  className="settingItemContainer"
                  style={{ direction: "ltr" }}
                >
                  <Form.Check
                    type="checkbox"
                    label="داخلی"
                    checked={this.state.insideCheck}
                    onChange={() =>
                      this.setState({ insideCheck: !this.state.insideCheck })
                    }
                  />
                  <Form.Check
                    type="checkbox"
                    label="بسته بندی"
                    checked={this.state.packCheck}
                    onChange={() =>
                      this.setState({ packCheck: !this.state.packCheck })
                    }
                  />
                  <Form.Check
                    type="checkbox"
                    label="ارسال"
                    checked={this.state.sendCheck}
                    onChange={() =>
                      this.setState({ sendCheck: !this.state.sendCheck })
                    }
                  />
                </div>
              )}

              {this.state.reportSelected === 3 && (
                <div className="settingItemContainer">
                  <div style={{ flex: "1" }}>
                    <CustomButton
                      title="انتخاب سوالات"
                      minHeight="35px"
                      onClick={this.onChooseQuestionsClick.bind(this)}
                    />
                  </div>
                </div>
              )}

              {this.state.reportSelected === 3 && (
                <div
                  className="settingItemContainer"
                  style={{ fontSize: "14px", fontFamily: "SFUIDisplayBold" }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      userSelect: "none",
                      cursor: "pointer",
                      alignItems: "center",
                    }}
                    onClick={this.onPoorClick.bind(this)}
                  >
                    <img
                      src={this.state.poorState ? poor : poor1}
                      alt=""
                      style={{ objectFit: "contain", height: "30px" }}
                    />
                    <div
                      style={{
                        fontFamily: "SFUIDisplay",
                        fontSize: "12px",
                        marginTop: "6px",
                      }}
                    >
                      ضعیف
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      userSelect: "none",
                      cursor: "pointer",
                      alignItems: "center",
                    }}
                    onClick={this.onMiddleClick.bind(this)}
                  >
                    <img
                      src={this.state.middleState ? middle : middle1}
                      alt=""
                      style={{ objectFit: "contain", height: "30px" }}
                    />
                    <div
                      style={{
                        fontFamily: "SFUIDisplay",
                        fontSize: "12px",
                        marginTop: "6px",
                      }}
                    >
                      متوسط
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      userSelect: "none",
                      cursor: "pointer",
                      alignItems: "center",
                    }}
                    onClick={this.onGoodClick.bind(this)}
                  >
                    <img
                      src={this.state.goodState ? good : good1}
                      alt=""
                      style={{ objectFit: "contain", height: "30px" }}
                    />
                    <div
                      style={{
                        fontFamily: "SFUIDisplay",
                        fontSize: "12px",
                        marginTop: "6px",
                      }}
                    >
                      خوب
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      userSelect: "none",
                      cursor: "pointer",
                      alignItems: "center",
                    }}
                    onClick={this.onExcellentClick.bind(this)}
                  >
                    <img
                      src={this.state.excellentState ? excellent : excellent1}
                      alt=""
                      style={{ objectFit: "contain", height: "30px" }}
                    />
                    <div
                      style={{
                        fontFamily: "SFUIDisplay",
                        fontSize: "12px",
                        marginTop: "6px",
                      }}
                    >
                      عالی
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div
              style={{
                width: "100%",
                maxWidth: "500px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              <div style={{ flex: "1" }}>
                <CustomButton
                  title="اعمال فیلتر"
                  loading={this.state.writingProgress}
                  imgHeight={20}
                  imgWidth={25}
                  minHeight="35px"
                  img={Tick}
                  onClick={this.onConfirm.bind(this)}
                />
              </div>
              <div style={{ minWidth: "10px" }} />
              <div style={{ flex: "0.8" }}>
                <CustomButton
                  title="انصراف"
                  imgHeight={19}
                  backColor="var(--black1)"
                  imgWidth={25}
                  minHeight="35px"
                  img={Cancel}
                  onClick={this.hideModal.bind(this)}
                />
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          show={this.state.ModalShow2}
          animation={true}
          size="sm"
          backdrop="static"
          backdropClassName="backdropClassName"
          onHide={this.hideModal2.bind(this)}
          centered
        >
          {this.state.ModalShow2 && (
            <QuestionView
              currentSelected={this.state.selectedQuestions}
              list={this.props.Questions}
              onConfirmQuestions={this.onConfirmQuestions.bind(this)}
              hideModal={this.hideModal2.bind(this)}
            />
          )}
        </Modal>

        <Modal
          show={this.state.ExcelDateModal}
          size="sm"
          animation={true}
          onHide={() => {
            this.setState({ ExcelDateModal: false });
          }}
          centered
        >
          <div className="settingContainer" style={{ padding: "10px" }}>
            <div className="ModalTitleSM">انتخاب بازه زمانی</div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                marginTop: "20px",
                padding: "5px",
                width: "100%",
              }}
            >
              <div className="settingItemContainer">
                <div className="settingLabel">شروع:</div>
                <DatePicker
                  ref={this.datepicker1}
                  value={this.state.dateValue1}
                  inputClass="form-control inputStyleForm textAlignCenter"
                  calendar="persian"
                  locale="fa"
                  weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                  format="YYYY/MM/DD"
                  animation
                  className="rmdp-mobile bluee"
                  onChange={(valuee) => this.dateChange1(valuee)}
                  maxDate={this.state.maxDateStart}
                  editable={false}
                  inputMode="none"
                  placeholder="شروع"
                />
              </div>
              <div className="settingItemContainer">
                <div className="settingLabel">پایان:</div>
                <DatePicker
                  ref={this.datepicker2}
                  value={this.state.dateValue2}
                  inputClass="form-control inputStyleForm textAlignCenter"
                  calendar="persian"
                  locale="fa"
                  weekDays={["ش", "ی", "د", "س", "چ", "پ", "ج"]}
                  format="YYYY/MM/DD"
                  animation
                  className="rmdp-mobile bluee"
                  onChange={(valuee) => this.dateChange2(valuee)}
                  minDate={this.state.minDate}
                  maxDate={this.state.maxDate}
                  editable={false}
                  inputMode="none"
                  placeholder="پایان"
                />
              </div>

              <div
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "20px",
                  alignItems: "center",
                }}
              >
                <div style={{ flex: "1" }}>
                  <CustomButton
                    title="دریافت فایل"
                    loading={this.state.excelProgress}
                    imgHeight={20}
                    imgWidth={25}
                    minHeight="35px"
                    ico={downloadIcon}
                    onClick={() => {
                      switch (this.state.reportSelected) {
                        case 2: {
                          this.GetPollCommentsExcel();
                          break;
                        }
                        case 3: {
                          this.GetPollResultsDetailExcel();
                          break;
                        }
                        default:
                          break;
                      }
                    }}
                  />
                </div>
                <div style={{ minWidth: "10px" }} />
                <div style={{ flex: "0.8" }}>
                  <CustomButton
                    title="انصراف"
                    imgHeight={19}
                    backColor="var(--black1)"
                    imgWidth={25}
                    minHeight="35px"
                    img={Cancel}
                    onClick={() => {
                      this.setState({ ExcelDateModal: false });
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
